module.exports = __webpack_public_path__ + "img/duty.e611662a.png";